import { styled } from "../../../../../../styles";

export const TooltipBox = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "2px",

  padding: "8px 12px",
  borderRadius: "4px",

  backgroundColor: "#4b4b4b",

  fontFamily: "$openSans",
});

export const TooltipValue = styled("span", {
  color: "$white",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
});

export const TooltipDate = styled("span", {
  color: "#D8D8D8",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
});
